import React from 'react';
import useFormValues from '../../../../cs/review/common/hook/queries/useFormValues';
import { Controller, useFormContext } from 'react-hook-form';

import FormField from '../../../../../components/common/FormField';
import BasicLabel from '../../../../../components/common/BasicLabel';
import { FormInput } from '../../../../../components/common/FomInput/FormInput';
import SelectField from '../../../../../components/common/SelectField';
import AdminFormWrap from '../AdminFormWrap/AdminFormWrap';

import { ADMIN_LEVEL_TYPE_LIST, ADMIN_STATUS_TYPE_LIST } from '../../common/constants';
import { setDateFormat } from '../../../../../lib/moment';

interface IAccountAdminEditFormProps {
  isMasterAccount?: boolean;
}

const AccountAdminEditForm = (props: IAccountAdminEditFormProps): JSX.Element => {
  const { email, createDate, updateDate } = useFormValues();
  const { isMasterAccount } = props;
  const { control } = useFormContext();

  return (
    <AdminFormWrap>
      <FormField label={<BasicLabel label={'이메일'} isRequired={true} />}>
        <div>{email}</div>
      </FormField>
      <FormField label={<BasicLabel label={'이름'} isRequired={true} />}>
        <FormInput
          id="name"
          name="name"
          label="name"
          placeholder="이름을 입력해주세요"
          limit={50}
          editable={true}
          required={true}
        />
      </FormField>
      <FormField label={<BasicLabel label={'비밀번호'} isRequired={true} />}>
        <Controller
          control={control}
          name="password"
          render={({ field: { onChange, value }, fieldState: { isDirty, error } }) => (
            <FormInput
              id="password"
              name="password"
              label="password"
              // 값이 없거나, 수정이 이뤄지지 않거나, 에러가 발생하지 않은 경우 플레이스 홀더를 노출
              placeholder={(!value && !isDirty) || !error ? '***********' : ''}
              editable={true}
              required={false}
              onChange={onChange}
              value={value}
            />
          )}
        />
      </FormField>
      <FormField label={<BasicLabel label={'비밀번호 확인'} isRequired={true} />}>
        <Controller
          control={control}
          name="passwordConfirm"
          render={({ field: { onChange, value }, fieldState: { isDirty, error } }) => (
            <FormInput
              id="passwordConfirm"
              name="passwordConfirm"
              label="passwordConfirm"
              // 값이 없거나, 수정이 이뤄지지 않거나, 에러가 발생하지 않은 경우 플레이스 홀더를 노출
              placeholder={(!value && !isDirty) || !error ? '***********' : ''}
              editable={true}
              required={false}
              onChange={onChange}
              value={value}
            />
          )}
        />
      </FormField>
      <FormField label={<BasicLabel label={'권한레벨'} isRequired={false} />}>
        <SelectField
          id="level"
          name="level"
          options={ADMIN_LEVEL_TYPE_LIST}
          editable={!!isMasterAccount}
          isRequired={false}
        />
      </FormField>
      <FormField label={<BasicLabel label={'관리자 상태'} isRequired={false} />}>
        <SelectField
          id="status"
          name="status"
          options={ADMIN_STATUS_TYPE_LIST}
          editable={!!isMasterAccount}
          isRequired={false}
        />
      </FormField>
      <FormField label={<BasicLabel label={'계정 생성 일자'} isRequired={false} />}>
        <div>{setDateFormat(createDate, 'LLL')}</div>
      </FormField>
      <FormField label={<BasicLabel label={'계정 수정 일자'} isRequired={false} />}>
        <div>{setDateFormat(updateDate, 'LLL')}</div>
      </FormField>
    </AdminFormWrap>
  );
};

export default AccountAdminEditForm;
